messages:
  errors:
    technical: "Er is een technische fout opgetreden: {code}"
    validation: Het bestand kon niet worden gevalideerd.
    uploadFailed: Er is een fout opgetreden tijdens het uploaden van het bestand. Probeer het later opnieuw.
enums:
  code:
    NO_SHEET: Geen tabblad gevonden.
    EMPTY_SHEET: Het tabblad bevat geen gegevens.
    UNKNOWN: Er is een onbekende fout opgetreden.
